/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var tab_items = document.getElementsByClassName("TabList__Item");

var toggle_tab_item_cta = function(active_collection) {
    console.log('active_colleciotn: ', active_collection)
    var tab_cta_buttons = document.getElementsByClassName("TabList-CTA-link");
    for (var i = 0; i < tab_cta_buttons.length; i++) {
        var cta_collection_handle = tab_cta_buttons[i].getAttribute("data-collection");
        console.log('button_collection_handle', cta_collection_handle)
        if(tab_cta_buttons[i].classList.contains('is-active')){
            console.log('is-active')
            tab_cta_buttons[i].classList.remove('is-active');
        } else {
            console.log('is NOT active')
        }
        if(cta_collection_handle == active_collection){
            tab_cta_buttons[i].classList.add('is-active');
        }
    }
}

var click_tab_item = function() {
    var clicked_collection_handle = this.getAttribute("data-collection");
    //console.log(clicked_collection_handle);
    toggle_tab_item_cta(clicked_collection_handle);
};

for (var i = 0; i < tab_items.length; i++) {
    tab_items[i].addEventListener('click', click_tab_item, false);
}



